<template>
  <div style="display: flex; justify-content: space-between; margin-left: 24px">
    <div>
      <div v-if="activeTab === 0" style="display: flex; align-items: center">
        <RoundedLabel
          @click="
            $store.commit('SHOW_ADD_FILTER_DIALOG', {
              hideStatus: true,
              hideTranslator: true,
              hideLanguage: true,
              hideCustomDropdown: true,
            })
          "
          leftIcon="pi pi-filter"
          :text="$t('general.addFilter')"
          size="l"
          class="bor-dark-blue"
          style="cursor: pointer; height: 40px; margin-right: 24px"
        />
        <FilterBreadcrumb :items="$store.state.filterBreadcrumbs" maxWidth="calc(100vw - 750px)"/>
      </div>
      <div v-else style="height: 60px; width: 10px"></div>
    </div>
    <div style="display: flex; align-items: center">
      <div
        v-if="
          activeTab === 0
            ? hasPermission('manage_users/edit/users')
            : hasPermission('manage_users/edit/groups')
        "
        v-tooltip="activeTab === 0 && !groups.length ? $t('general.createGroupForUsers') : ''"
        style="display: flex; align-content: center; align-items: center; padding-right: 20px"
      >
        <div
          v-if="!showAddUserOrGroup && activeTab === 0"
          style="width: 120px; text-align: right; margin-right: 12px"
        >
          {{$t('general.addUser')}}
        </div>
        <div
          v-if="!showAddUserOrGroup && activeTab === 1"
          style="width: 120px; text-align: right; margin-right: 12px"
        >
          {{$t('general.addGroup')}}
        </div>
        
        <Button v-if="activeTab === 0" class="bor-dark-blue border-radius-8 bg-transparent"
                style="width: 42px; height: 42px"
                @click="addUserDialog = !addUserDialog">
          <i
            class="pi pi-plus col-dark-blue"
            style="font-size:16px; font-weight:600"
          />
        </Button>
        <ManageUserDialog v-if="activeTab === 0" v-model:is-visible="addUserDialog"/>
        <AddGroupDialog v-if="activeTab === 1"/>
      </div>
      
      <SearchField
        v-model="searchText"
        style="padding-right: 38px"
        :blurFunction="onBlurSearchField"
      />
    </div>
  </div>
  
  
  <div style="overflow: hidden; padding: 40px 24px 0 24px; height: calc(100vh - 163px)">
    <TabView v-model:activeIndex="activeTab">
      <TabPanel
        :header="$t('general.users')"
        :disabled="showAddUserOrGroup || showEditUser || showEditGroup"
      >
        <div>
          <div
            class="bor-menu-color col-dark-blue"
            style="display: flex; font-weight: 100; font-size: 16px; line-height: 16px; width: 100%; height: 40px; border-style: solid; border-width: 0 0 1px 0"
          >
            <div
              style="width: 30%; height: 40px; display: flex; cursor: pointer"
              @click="changeSort('id')"
            >
              {{$t('general.username')}}
              <div v-if="sortColumn === 'id'">
                <i v-if="sortAsc" class="pi pi-angle-up" style="margin-left: 4px"></i>
                <i v-if="!sortAsc" class="pi pi-angle-down" style="margin-left: 4px"></i>
              </div>
            </div>
            <div
              style="width: 20%; height: 40px; display: flex; cursor: pointer"
              @click="changeSort('role')"
            >
              {{$t('general.role')}}
              <div v-if="sortColumn === 'role'">
                <i v-if="sortAsc" class="pi pi-angle-up" style="margin-left: 4px"></i>
                <i v-if="!sortAsc" class="pi pi-angle-down" style="margin-left: 4px"></i>
              </div>
            </div>
            <div
              style="width: 15%; height: 40px; display: flex; cursor: pointer"
              @click="changeSort('group')"
            >
              {{$t('general.group')}}
              <div v-if="sortColumn === 'group'">
                <i v-if="sortAsc" class="pi pi-angle-up" style="margin-left: 4px"></i>
                <i v-if="!sortAsc" class="pi pi-angle-down" style="margin-left: 4px"></i>
              </div>
            </div>
            <div style="width: 10%; height: 40px; display: flex"></div>
          </div>
          
          <!--///////////////////////////////////////////////-->
          
          <div style="height: calc(100vh - 312px); overflow: auto" id="usersRef">
            <div
              v-for="(item, index) in users"
              :key="index"
              class="bor-menu-color col-dark-blue"
              style="display: flex; width: 100%; margin-bottom: 16px; border-style: solid; border-width: 0 0 1px 0"
            >
              <div style="width: 30%; display: flex; align-items: center; height: 80px">
                {{item.id}}
              </div>
              <div style="width: 20%; display: flex; align-items: center">
                {{item.role}}
              </div>
              <div style="width: 16%; display: flex; align-items: center">
                <RoundedLabel
                  v-if="item.groups"
                  v-for="group in item.groups"
                  @click="
                    $store.commit('ADD_FILTER_BREADCRUMB', {
                      name: group.name,
                      type: 'GROUP',
                    });
                    $emitter.emit('search-users', null);
                  "
                  :text="group.name"
                  :lineThrough="!checkGroupExistence(group.name)"
                  class="bor-menu-color"
                  style="cursor: pointer; margin-right: 10px"
                />
              </div>
              <div style="width: 10%; display: flex; align-items: center; margin: auto 0 auto auto">
                <RoundedLabel
                  v-if="false"
                  @click="
                    currentUser = item;
                    showEditUser = true;
                    showAddUserOrGroup = false;
                  "
                  leftIcon="pi pi-cog"
                  class="bor-menu-color"
                  style="margin-right: 10px; cursor: pointer"
                />
                
                <RoundedLabel
                  v-if="hasPermission('manage_users/edit/users')"
                  @click="openManageUserDialog(index)"
                  leftIcon="pi pi-cog"
                  v-tooltip="$t('tooltip.editUser')"
                  class="bor-menu-color"
                  style="margin-right:10px; cursor:pointer;"
                />
                <ManageUserDialog v-if="index === manageUserDialogNumber"
                                  v-model:is-visible="manageUserDialog"
                                  :user="item"/>
                
                <RoundedLabel
                  v-if="item.id !== 'admin' && hasPermission('manage_users/delete/users')"
                  @click="
                    $store.commit('SHOW_CONFIRM_DIALOG', {
                      dialogTitle: 'dialog.areYouSure',
                      dialogContent: { t: 'dialog.deleteUser', e: [item.id] },
                      confirmCallback: () => {
                        deleteUser(item);
                        $store.commit('SHOW_SNACKBAR', {
                          snackbarContent: { t: 'snackbar.userDeleted' },
                          snackbarBtnText: $t('snackbar.undo'),
                          snackbarBtnCallback: () => {
                            undoDeleteUser();
                            $store.commit('SHOW_SNACKBAR', {
                              snackbarText: 'snackbar.userRestored',
                              snackbarContent: { t: 'snackbar.userRestored' },
                              snackbarType: 'info',
                              snackbarLife: 3000
                            });
                          },
                        });
                      },
                    })
                  "
                  v-tooltip="$t('tooltip.deleteUser')"
                  leftIcon="pi pi-trash"
                  class="bor-menu-color"
                  style="cursor: pointer"
                />
              </div>
            </div>
            <div
              v-if="addingUsers"
              style="float: left; width: 100%; height: 80px; display: flex; align-items: center; justify-content: center"
            >
              <ProgressSpinner/>
            </div>
            <div
              v-if="added0Users"
              style="float: left; width: 100%; height: 80px; display: flex; justify-content: center"
            >
              {{$t('general.noMoreUsers')}}
            </div>
          </div>
        </div>
      </TabPanel>
      <TabPanel
        :header="$t('general.groups')"
        :disabled="showAddUserOrGroup || showEditUser || showEditGroup"
      >
        <div>
          <div
            class="bor-menu-color col-dark-blue"
            style="display: flex; font-weight: 100; font-size: 16px; line-height: 16px; width: 100%; height: 40px; border-style: solid; border-width: 0 0 1px 0"
          >
            <div
              style="width: 29%; height: 40px; display: flex; cursor: pointer"
              @click="changeSort('id')"
            >
              {{$t('general.groupName')}}
              <div v-if="sortColumn === 'id'">
                <i v-if="sortAsc" class="pi pi-angle-up" style="margin-left: 4px"></i>
                <i v-if="!sortAsc" class="pi pi-angle-down" style="margin-left: 4px"></i>
              </div>
            </div>
            <div
              style="width: 25%; height: 40px; display: flex; cursor: pointer"
              @click="changeSort('assetCount')"
            >
              {{$t('general.assetCount')}}
              <div v-if="sortColumn === 'assetCount'">
                <i v-if="sortAsc" class="pi pi-angle-up" style="margin-left: 4px"></i>
                <i v-if="!sortAsc" class="pi pi-angle-down" style="margin-left: 4px"></i>
              </div>
            </div>
            <div
              style="width: 25%; height: 40px; display: flex; cursor: pointer"
              @click="changeSort('jobCount')"
            >
              {{$t('general.jobCount')}}
              <div v-if="sortColumn === 'jobCount'">
                <i v-if="sortAsc" class="pi pi-angle-up" style="margin-left: 4px"></i>
                <i v-if="!sortAsc" class="pi pi-angle-down" style="margin-left: 4px"></i>
              </div>
            </div>
            <div style="width: 20%; height: 40px; display: flex; "></div>
          </div>
          
          <!--///////////////////////////////////////////////-->
          
          <div style="height: calc(100vh - 312px); overflow: auto" id="groupsRef">
            <div
              v-for="(item, index) in groups"
              :key="index"
              class="bor-menu-color col-dark-blue"
              style="display: flex; width: 100%; margin-bottom: 16px; border-style: solid; border-width: 0 0 1px 0"
            >
              <div style="width: 30%; display: flex; align-items: center; height: 80px">
                {{item.name}}
              </div>
              <div style="width: 25%; display: flex; align-items: center">
                {{(groupInformation.get(item.name) ? groupInformation.get(item.name).assets : 0)}}
              </div>
              <div style="width: 25%; display: flex; align-items: center">
                {{(groupInformation.get(item.name) ? groupInformation.get(item.name).jobs : 0)}}
              </div>
              <div style="width: 20%; padding-right: 50px; display: flex; align-items: center; justify-content: right">
                <RoundedLabel
                  v-if="hasPermission('manage_users/delete/groups')"
                  @click="openDeleteUserDialog(item)"
                  v-tooltip="$t('tooltip.deleteGroup')"
                  leftIcon="pi pi-trash"
                  class="bor-menu-color"
                  style="cursor: pointer"
                />
              </div>
            </div>
            <div
              v-if="addingGroups"
              style="float: left; width: 100%; height: 80px; display: flex; align-items: center; justify-content: center"
            >
              <ProgressSpinner/>
            </div>
            <div
              v-if="added0Groups"
              style="float: left; width: 100%; height: 80px; display: flex; justify-content: center"
            >
              {{$t('general.noMoreGroups')}}
            </div>
          </div>
        </div>
        
        <!--
        
        $store.commit('SHOW_CONFIRM_DIALOG', {
                              dialogTitle: 'dialog.areYouSure',
                              dialogContent: { t: 'dialog.deleteGroup', e: [item.name] },
                              confirmCallback: () => {
                                deleteGroup(item);
                                $store.commit('SHOW_SNACKBAR', {
                                  snackbarContent: { t: 'snackbar.groupDeleted' },
                                  snackbarBtnText: $t('snackbar.undo'),
                                  snackbarBtnCallback: () => {
                                    undoDeleteGroup();
                                    $store.commit('SHOW_SNACKBAR', {
                                      snackbarText: 'snackbar.groupRestored',
                                      snackbarContent: { t: 'snackbar.groupRestored' },
                                      snackbarType: 'info',
                                      snackbarLife: 3000
                                    });
                                  },
                                });
                              },
                            })
        -->
        
        
        <pDialog v-model:visible="deleteGroupDialog" :header="'Delete Group'">
          <div
            style="height: 350px; background-color: transparent; display: flex; flex-direction: column; align-items: center; justify-content: space-between">
            <div style="gap: 50px; flex-direction: column" class="flex-center">
              <div style="display: flex; gap: 12px">
                <i class="pi pi-info-circle" style="padding-top: 3px"/>
                <div style="display: flex; gap: 3px">
                  There are users and assets using this group. Choose a group to replace
                  '
                  <div style="font-weight: bold">
                    {{currentDeleteUserGroup.name}}
                  </div>
                  '
                </div>
              
              </div>
              
              <AutoCompleteGroup style="width: 228px" v-model:model-value="currentReplaceDeleteUserGroup"/>
            </div>
            
            <div style="width: 100%; display: flex; justify-content: space-between">
              
              <Button
                @click="deleteGroupDialog = false; currentDeleteUserGroup = undefined"
                :label="$t('general.cancel')"
                class="border-radius-8 col-white bor-transparent bg-dark-blue"
                style="width: 110px; height: 40px; padding: 7px 6px 6px 8px"
              />
              
              
              <Button
                @click="deleteGroup(currentDeleteUserGroup, currentReplaceDeleteUserGroup)"
                :label="$t('general.ok')"
                class="border-radius-8 col-white bor-transparent bg-dark-blue"
                style="width: 110px; height: 40px; padding: 7px 6px 6px 8px"
              />
            </div>
          </div>
        </pDialog>
      </TabPanel>
      
      
      <TabPanel
        v-if="isApproveUserAllowed"
        :header="$t('manageUsers.approveUser')"
        :disabled="showAddUserOrGroup || showEditUser || showEditGroup">
        <div style="height: calc(100vh - 288px)">
          <div v-if="approvalUsers.length === 0" style="display: flex; justify-content: center; padding-top: 50px">
            No users to approve
          </div>
          <DataTable v-if="approvalUsers.length > 0"
                     class="p-datatable-replace-media"
                     :value="approvalUsers"
                     scrollable
                     scrollHeight="flex"
                     removableSort
                     sortMode="multiple"
                     @rowSelect="onClickApprovalUserRow"
                     selectionMode="single"
                     :rows="8">
            <Column field="id" header="Id" sortable class="flex-center"></Column>
            <Column field="firstname" header="Firstname" sortable class="flex-center"></Column>
            <Column field="name" header="Lastname" sortable class="flex-center"></Column>
            <Column field="costCenter" header="CostCenter" sortable class="flex-center"></Column>
            <Column header="" class="flex-center">
              <template #body="slotProps">
                <span
                  class="transitions flex-center"
                >
                  
                  <RoundedLabel
                    @click="
                      $store.commit('SHOW_CONFIRM_DIALOG', {
                        dialogTitle: 'dialog.areYouSure',
                        dialogContent: {
                          t: 'dialog.deleteJob',
                          e: [slotProps.data.name],
                        },
                        confirmCallback: () => {
                          deleteApproveUser(slotProps.data);
                          $store.commit('SHOW_SNACKBAR', {
                            snackbarContent: { t: 'snackbar.jobDeleted' },
                            snackbarBtnText: $t('snackbar.undo'),
                          });
                        },
                      })
                    "
                    leftIcon="pi pi-trash"
                    class="bor-menu-color"
                    style="margin-right: 10px; cursor: pointer"
                  />
      
                </span>
              </template>
            </Column>
          </DataTable>
          
          <ManageUserDialog :user="selectedApprovalUser" :is-visible="approvalUsersDialog"></ManageUserDialog>
        </div>
      </TabPanel>
    </TabView>
  </div>
</template>

<script src="./ManageUsersView.ts"></script>
